import { useCallback, useEffect, useRef } from "react";
import { callFunctionIfExists } from "../utils/GeneralUtils";
import Constants from "../utils/Constants";

// Custom hook for handling when user presses a key.
const useKeyEvent = (event, key = Constants.KEYS.ESCAPE, disabled = false) => {
  const eventRef = useRef();
  const keyRef = useRef();
  const disabledRef = useRef();
  eventRef.current = event;
  keyRef.current = key;
  disabledRef.current = disabled;

  const _handleKeyDown = useCallback((event) => {
    if (disabledRef.current || event.keyCode !== keyRef.current) return;

    callFunctionIfExists(eventRef.current);
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", _handleKeyDown);

    return () => document.removeEventListener("keydown", _handleKeyDown);
  }, [_handleKeyDown]);
};

export default useKeyEvent;
